import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import StarIcon from "@mui/icons-material/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { serviceKeys } from "@/constants/serviceKeys";
// Utility to transform service key into readable label
function formatLabel(key) {
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

// Map special keys to custom display labels or multiple labels
function getDisplayLabels(key) {
  switch (key) {
    case "first_time_home_buyer_loans":
      return ["First-Time Home Buyer Loans"];
    case "government_backed_loans":
      return ["FHA Loans", "VA Loans"];
    case "credit_score_consultation":
      return ["Credit Score Improvement Consulting"];
    default:
      return [formatLabel(key)];
  }
}

export default function ServicesSection({ VendorDetail }) {
  const vendorData = VendorDetail || {};
  const availableKeys = serviceKeys.filter((key) => vendorData[key]);
  //if (!availableKeys.length) return null;
  const displayLabels = availableKeys.flatMap(getDisplayLabels);

  // Rating calculation
  const rating = Number(vendorData.vendorRating) || 0;
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

  const formatReviews = (count = 0) => {
    if (count >= 1e6) return `${(count / 1e6).toFixed(1)}M`;
    if (count >= 1e3) return `${(count / 1e3).toFixed(1)}k`;
    return count;
  };

  return (
    <Box
      sx={{
        bgcolor: "#fbfcff",
        border: "1px solid #d9d9d9",
        p: { xs: 1, md: 2 },
        mt: 1,
      }}
    >
      {/* Location and Rating */}
      {/* Location and Rating */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // <-- spread items
          mb: 1,
          flexWrap: "wrap",
          gap: { xs: 2, sm: 3, md: 4 },
        }}
      >
        {/* Location */}
        <Typography variant="subtitle1" fontWeight={600} component="span">
          Location:{" "}
          <Typography component="span" fontWeight={400}>
            {vendorData.address || "N/A"}
          </Typography>
        </Typography>

        {/* Stars & Review Count */}
        {vendorData.status === 'approved' && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {[...Array(fullStars)].map((_, i) => (
            <StarIcon key={i} sx={{ color: "gold", fontSize: 20 }} />
          ))}
          {hasHalf && <StarHalfIcon sx={{ color: "gold", fontSize: 20 }} />}
          {[...Array(emptyStars)].map((_, i) => (
            <StarBorderIcon key={i} sx={{ color: "gold", fontSize: 20 }} />
          ))}
          <Typography variant="body2" sx={{ ml: 1 }}>
          {rating} ({formatReviews(vendorData.totalReviews)}) Rating
          </Typography>
        </Box>
        )}
      </Box>

      {/* Services Grid */}
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Services Provided
      </Typography>
      <Grid container spacing={0}>
        {/* {displayLabels.map((label, idx) => (
          <Grid item xs={10} sm={6} md={3} key={idx}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CheckIcon sx={{ color: 'Green' }} />
              <Typography variant="body2">{label}</Typography>
            </Box>
          </Grid>
        ))} */}
        {(vendorData.services || []).map((service, idx) => (
          <Grid item xs={10} sm={6} md={3} key={service._id || idx}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CheckIcon sx={{ color: "Green" }} />
              <Typography variant="body2">{service.servicesName}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
